let IdNamePair = require('./IdNamePair');

module.exports = class Subejct extends IdNamePair {};
